export default __webpack_public_path__ + "static/media/Journal@32.92ffd979.svg";